<!--
 * @Description: 教学日志评定
 * @Author: ZSC
 * @Date: 2023-04-26 13:55:50.22
 * @LastEditors: PF
 * @LastEditTime: 2024-08-02 11:03:50
-->
<template>
    <div>
      <el-dialog class="w800 h630" :model-value="openPingDing" :close-on-click-modal="false" :show-close="false"
        destroy-on-close>
        <template #header>
          <div class="header-left">
            <el-icon class="header-icon">
              <Edit />
            </el-icon>
            <span class="header-title">评定</span>
          </div>
          <div class="header-right">
            <el-button type="info" text @click="closeWindow('openPingDing', emits, false)">
              <el-icon>
                <Close />
              </el-icon>
            </el-button>
          </div>
        </template>
        <el-form ref="ruleFormRef" :model="ruleForm" label-width="120px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="评分" prop="pf" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                <el-input-number v-model="ruleForm.pf" :min="0" :max="100" clearable placeholder="请输入评分"></el-input-number>
              </el-form-item>
            </el-col>
              <el-col :span="24">
              <el-form-item label="等级" prop="dj" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                <el-radio-group v-model="ruleForm.dj" filterable clearable>
                  <el-radio  v-for="item in pdgjData" :key="item.value" :label="item.value" >{{ item.name }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="综合评价" prop="zhpj" >
                <el-input v-model="ruleForm.zhpj" type="textarea" :rows="4" placeholder="综合评价" clearable />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <template #footer>
          <div class="dialog-footer">
            <div></div>
            <div class="footer_but">
              <el-button type="primary" @click="submit()">保存</el-button>
              <el-button type="info" @click="closeWindow('openPingDing', emits, false)">关闭</el-button>
            </div>
          </div>
        </template>
      </el-dialog>
    </div>

  </template>
<script setup>
import { defineEmits, ref, defineProps, watch, unref } from 'vue'
import { submitEditForm, closeWindow, loadData, loadSelect } from '@/api/common.js'

const props = defineProps({ openPingDing: { type: Boolean, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['update:openPingDing', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({
})

// 评定等级
const pdgjData = ref({})

watch(
  () => props.openPingDing,
  () => {
    if (props.openPingDing) {
      loadSelect({ url: '/api/v2/jiaowu/jiaoxuegongzuojiancha/pingjiadengji', data: pdgjData })
      loadData({
        url: '/api/v2/jiaowu/jiaoxuegongzuojiaoxuerizhijiancha/' + props.row.id,
        ruleForm
      })
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  submitEditForm({
    url: '/api/v2/jiaowu/jiaoxuegongzuojiaoxuerizhijiancha',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function () {
      closeWindow('openPingDing', emits, true)
    }
  })
}
</script>
